import React from 'react';
import { HelpCircle } from 'lucide-react';

interface ToolHeaderProps {
  title: string;
  description?: React.ReactNode;
  cost?: string;
}

export const ToolHeader: React.FC<ToolHeaderProps> = ({ title, description, cost }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold text-slate-900 capitalize flex items-center gap-2">
          {title}
          {cost && (
            <span className="text-sm font-normal px-3 py-1 bg-primary-100 text-primary-700 rounded-full">
              Cost: {cost}
            </span>
          )}
        </h2>
      </div>

      {description && (
        <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-6 flex items-start gap-3">
          <HelpCircle className="text-blue-500 shrink-0 mt-0.5" size={20} />
          <div className="text-sm text-blue-800 space-y-1">
            {description}
          </div>
        </div>
      )}
    </div>
  );
};
